<h2>Tradition küsst Zukunft.</h2>
<p class="about">
  Als Informatiker im Verein hatte ich natürlich das Ziel den Traditionsverein
  ins nächste Zeitalter zu heben. Kommunikation fand überwiegend über Brief,
  Whatsapp und Email statt. Das hat super funktioniert aber da war noch viel
  Luft nach oben. So entwickelte sich langsam die Idee zu einem Vereinseigenen
  Intranet.
</p>
<h2>Performance ist key.</h2>
<p class="about">
  Nach ein paar Überlegungen und Planung entstand der erste Prototyp auf
  Wordpress. Hier konnte mich aber die Performance und Zukunftsaussichten nicht
  überzeugen. Ich wollte, dass der Login schnell und umkompliziert funktioniert
  und die Seite sich wie eine Mobile-App anfühlt. Auf der Suche nach einer
  geeigneten Plattform bin ich dann auf Angular in Kombination mit einem ASP.NET
  Server gestoßen. Da ich beide Technologien bisher noch nicht verwendet hab,
  beschenkte ich mich selber mit passenden Kursen von Udemy.
</p>
<h2>Version 1</h2>
<p class="about">
  Um überhaupt mal ans Ziel zu kommen habe ich bei meiner Planung
  berücksichtigt, so schnell wie möglich ein Userfeedback zu bekommen und
  erstmal mit den einfachsten Funktionen zu starten: Authentifizierung, Posts
  schreiben, Profil bearbeiten und Mitglieder suchen. Beim Design habe ich mich
  an altbewährten orientiert und viele Sachen aus Facebook übernommen, damit
  Mitglieder gleich wissen wie die App zu bedienen ist. Nach ein bisschen mehr
  als 200 Stunden war dann der erste Prototyp fertig.
</p>
<h2>Die Enttäuschung.</h2>
<p class="about">
  Nach dem erfoglreichen Deployment auf dem Server habe ich zuerst den Vorstand
  + Ausschussmitglieder auf die App berechtigt und ein 10 Minütiges
  Schulungsvideo erstellt. Die Reaktionen auf das Video waren sehr euphorisich
  und ich begann die Aktivitäten auf der Seite zu beobachten. Doch sie kamen
  irgendwie nicht. Des Öfteren habe ich noch versucht, das Thema anzusprechen, jedoch ohne wirklichen Erfolg. Irgendwann hab ich das Projekt für mich
  auf Eis gelegt - jedoch den Lauf als sehr positiv erachtet, da ich durch die
  Onlinekurse und erlernte Fähigkeiten in ASP.NET und Angular neue
  Jobmöglichkeiten und sogar einen neuen Job bekommen habe.
</p>
<h2>Fazit.</h2>
<p class="about">
  Auch wenn es am Ende nicht genutzt wird, nehme ich einiges an neuem Wissen und
  Erkenntnissen aus diesem Projekt mit. Ich konnte mich intensiv mit dem
  Debuggen von Web-Applikationen beschäftigen, habe mir Angular und ASP.NET im
  Selbststudium beigebracht und kann dies aktuell super in meiner Arbeit
  verwenden. Weitere Projekte mit ASP.NET und Angular werden vielleicht in naher
  Zukunft folgen.
  <br>
  <br>
  Anfang 2024 habe ich diesem Projekt dann noch ein komplettes
  Redesign verpasst um mich mit neuen Webdesign Trends zu beschäftigen.
</p>
